module.exports = "<div class=\"no_widget_data_to_display\">{{noDataToDisplay}}</div>";